import { Guid } from 'Lib/Guid';

export enum AssociatedTestType {
  Measured = 'measured',
  Imported = 'imported',
  AutoImported = 'autoImported',
  External = 'external',
}

export interface ImportedComponent {
  id: Guid;
  component: React.ReactNode;
}

export const AssociatedTestTypes = {
  [AssociatedTestType.Measured]: {
    path: '.MeasuredTest',
    label: 'Measured as part of this test',
  },
  [AssociatedTestType.Imported]: {
    path: '.ImportedTest',
    label: 'Import from another test',
  },
  [AssociatedTestType.AutoImported]: {
    path: '.ImportedTest',
    label: 'Automatically import from another test on this sample',
  },
  [AssociatedTestType.External]: {
    path: '.ExternalTest',
    label: 'External source (final result only)',
  },
};
